import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";

// Start a quiz attempt - V2: identity comes from the JWT only, no studentId is sent.
export const startQuizAttempt = async (quizId, lessonId) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.post(
			`${CONFIG.SCHOOLURL}/api/v2/student/quiz-attempts/start`,
			{
				quizId,
				lessonId
			},
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		console.error("Error starting quiz attempt:", { status: error.response?.status, message: error.message });
		return null;
	}
};

// Submit an answer for a quiz question - V2: attemptId moves to the URL path, JWT is now
// attached (the legacy call sent none at all), and isCorrect is no longer sent - the backend
// always computes correctness server-side.
export const submitQuizAnswer = async (quizAttemptId, quizQuestionId, userAnswer, answerTimeSeconds) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.post(
			`${CONFIG.SCHOOLURL}/api/v2/student/quiz-attempts/${quizAttemptId}/answers`,
			{
				quizQuestionId,
				userAnswer,
				answerTimeSeconds
			},
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		console.error("Error submitting quiz answer:", { status: error.response?.status, message: error.message });
		throw error;
	}
};

// Complete a quiz attempt - V2: JWT is now attached (the legacy call sent none at all).
export const completeQuizAttempt = async (attemptId) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.post(
			`${CONFIG.SCHOOLURL}/api/v2/student/quiz-attempts/${attemptId}/complete`,
			{},
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		console.error("Error completing quiz attempt:", { status: error.response?.status, message: error.message });
		return null;
	}
};
